(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('allcollection-slider')) {
    customElements.define(
      'allcollection-slider',
      class LookSlider extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.slider = this.querySelector('.swiper');
          this.sliderSettings = JSON.parse(this.querySelector('#setting-data').innerText);

          if (window.innerWidth < 768) {
            this.init();
          }
        }

        init() {
          new Swiper(this.slider, this.sliderSettings);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["animated-collection"] && !Shopify.designMode) return;
  try {
    
  class AnimatedCollection {
    constructor(section) {
      this.section = section;
      this.container = section.container;
      this.buttons = this.container.querySelectorAll('[data-hover-target]');
      this.images = this.container.querySelectorAll('[data-collection-image]');
      this.rafId = null;
      this.init();
    }

    init() {
      if (!this.buttons.length || !this.images.length) return;

      this.buttons.forEach((btn) => {
        btn.addEventListener('mouseenter', (e) => {
          if (window.innerWidth >= 768) {
            this.setActive(btn.getAttribute('data-hover-target'));
          }
        });
      });

      this.initMobileScroll();

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.initMobileScroll();
        }, 250);
      });
    }

    setActive(targetId) {
      this.buttons.forEach((btn) => {
        btn.classList.toggle('is-selected', btn.getAttribute('data-hover-target') === targetId);
      });

      this.images.forEach((img) => {
        img.classList.toggle('is-visible', img.id === targetId);
      });
    }

    initMobileScroll() {
      const isMobile = window.innerWidth < 768;

      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
      }

      if (isMobile) {
        this.scrollHandler = () => {
          if (!this.rafId) {
            this.rafId = requestAnimationFrame(() => {
              this.updateActiveOnScroll();
              this.rafId = null;
            });
          }
        };

        window.addEventListener('scroll', this.scrollHandler);
        this.updateActiveOnScroll();
      }
    }

    updateActiveOnScroll() {
      const midpoint = window.innerHeight / 2;

      for (let i = 0; i < this.images.length; i++) {
        const rect = this.images[i].getBoundingClientRect();

        if (rect.top <= midpoint && rect.bottom >= midpoint) {
          const targetId = this.images[i].id;
          const btn = this.buttons[i];

          if (btn && !btn.classList.contains('is-selected')) {
            this.buttons.forEach((b) => b.classList.remove('is-selected'));
            btn.classList.add('is-selected');
          }
          break;
        }
      }
    }

    onUnload() {
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
      }
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
      }
    }
  }

  if (typeof register === 'function') {
    register('animated-collection', {
      onLoad() {
        this.animatedCollection = new AnimatedCollection(this);
      },
      onUnload() {
        if (this.animatedCollection) {
          this.animatedCollection.onUnload();
        }
      },
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof register !== 'function') {
      document.querySelectorAll('[data-section-type="animated-collection"]').forEach((section) => {
        new AnimatedCollection({ container: section });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-related-products"] && !Shopify.designMode) return;
  try {
    
  class TabSwitch extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeTabs();
    }

    initializeTabs() {
      this.tabButtons = this.querySelectorAll('input[type="radio"]');
      this.relatedProducts = this.querySelector('product-recommendations');
      this.recentlyViewed = this.querySelector('recently-viewed');

      // Hide recently viewed by default
      if (this.recentlyViewed) {
        this.recentlyViewed.style.display = 'none';
      }

      // Add event listeners to tab buttons
      this.tabButtons.forEach((button) => {
        button.addEventListener('change', this.handleTabChange.bind(this));
      });

      // Initialize the first tab as active
      const checkedTab = this.querySelector('input[type="radio"]:checked');
      if (checkedTab) {
        this.handleTabChange({ target: checkedTab });
      }
    }

    handleTabChange(event) {
      const tabIndex = event.target.dataset.tabIndex;

      if (tabIndex === '1') {
        // Show related products
        if (this.relatedProducts) {
          this.relatedProducts.style.display = 'block';
          // Initialize related products if not already loaded
          if (!this.relatedProducts.classList.contains('product-recommendations--loaded')) {
            this.relatedProducts.initializeRecommendations?.();
          }
        }
        if (this.recentlyViewed) {
          this.recentlyViewed.style.display = 'none';
        }
      } else if (tabIndex === '2') {
        // Show recently viewed
        if (this.recentlyViewed) {
          this.recentlyViewed.style.display = 'block';
          // Initialize recently viewed if not already loaded
          if (!this.recentlyViewed.classList.contains('product-recommendations--loaded')) {
            this.recentlyViewed.initializeRecentlyViewed?.();
          }
        }
        if (this.relatedProducts) {
          this.relatedProducts.style.display = 'none';
        }
      }

      // Update active state for labels
      this.updateActiveStates(event.target);
    }

    updateActiveStates(activeInput) {
      // Remove active class from all labels
      const labels = this.querySelectorAll('.tab--button');
      labels.forEach((label) => {
        label.classList.remove('active');
      });

      // Add active class to the parent label of checked input
      const activeLabel = activeInput.closest('.tab--button');
      if (activeLabel) {
        activeLabel.classList.add('active');
      }
    }
  }

  customElements.define('tab-switch', TabSwitch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('look-slider')) {
    customElements.define(
      'look-slider',
      class LookSlider extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.slider = this.querySelector('.swiper');
          this.sliderSettings = JSON.parse(this.querySelector('#setting-data').innerText);

          if (window.innerWidth < 768) {
            this.init();
          }
        }

        init() {
          new Swiper(this.slider, this.sliderSettings);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-description"] && !Shopify.designMode) return;
  try {
    
  class SizeTab extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeTabs();
    }

    initializeTabs() {
      this.tabButtons = this.querySelectorAll('input[type="radio"]');
      this.relatedProducts = this.querySelector('.size-section');
      this.recentlyViewed = this.querySelector('.video-text-section');

      // Add event listeners to tab buttons
      this.tabButtons.forEach((button) => {
        button.addEventListener('change', this.handleTabChange.bind(this));
      });

      // Initialize the first tab as active
      const checkedTab = this.querySelector('input[type="radio"]:checked');
      if (checkedTab) {
        this.handleTabChange({ target: checkedTab });
      }
    }

    handleTabChange(event) {
      const tabIndex = event.target.dataset.tabIndex;

      if (tabIndex === '1') {
        // Show related products
        if (this.relatedProducts) {
          this.relatedProducts.classList.remove('hidden');
        }
        if (this.recentlyViewed) {
          this.recentlyViewed.classList.add('hidden');
        }
      } else if (tabIndex === '2') {
        if (this.recentlyViewed) {
          this.recentlyViewed.classList.remove('hidden');
        }
        if (this.relatedProducts) {
          this.relatedProducts.classList.add('hidden');
        }
      }

      // Update active state for labels
      this.updateActiveStates(event.target);
    }

    updateActiveStates(activeInput) {
      const labels = this.querySelectorAll('.tab--button');
      labels.forEach((label) => {
        label.classList.remove('active');
      });

      const activeLabel = activeInput.closest('.tab--button');
      if (activeLabel) {
        activeLabel.classList.add('active');
      }
    }
  }

  customElements.define('size-tab', SizeTab);

  } catch(e) { console.error(e); }
})();
})();
